import React from 'react'
import playBook from '../img/playbook.jpg'
const Section_4 = () => {
    return (
        <div className="js-show-on-scroll xl:p-[4rem] xl:mt-20 text-white bg-[#67bdb7] rounded-lg grid xl:grid-cols-3 xl:mx-[8rem] xl:gap-4 bg-[url('https://thailand.acclime.com/wp-content/uploads/panel-bg.png')] bg-cover mt-10 mx-4 grid-cols-1 p-8">
            <div className=' xl:p-0 p-6 mt-3 '>
                <div className='flex justify-center items-center'>
                    <img src={playBook} alt="playbook" className=' -rotate-12 xl:w-[60%] h-auto rounded-sm' />
                </div>
            </div>
            <div className='  xl:col-span-2 '>
                <p className=' text-sm opacity-50 xl:text-left text-center'>Free Download</p>
                <h1 className=' text-[36px] font-semibold xl:text-left text-center '>Thailand Incorporation Playbook.</h1>
                <p className=' text-[20px] xl:text-left text-center'>Our in-depth guide covers everything you need to know about starting & managing your business in Thailand.</p>
                <div className=' xl:block flex items-center justify-center'>
                    <button className='mt-5 min-w-[160px] h-[45px] text-center rounded-full text-white bg-[#fe8200] border-[#fe8200] border-[3px] text-[16px] transition delay-100 ease-in hover:bg-white hover:text-[#fe8200] hover:border-white'>Download now</button>
                </div>

            </div>
        </div>
    )
}

export default Section_4